import React, { FC } from 'react';
import { FormikProps } from 'formik';

import { Box, Typography } from '@mui/material';
import { Editor } from '@tiptap/react';

import CustomTextField from '../../../common/CustomTextField';
import genericClasses from '../../../../theme/GenericClasses';
import { TextFieldVariants } from '../../../../helpers/Constants';
import EmailEditor from '../../../common/EmailEditor';
import strings from '../../../../localization';

import styles from './styles';

interface ICampaignEmailTemplate {
  formik: FormikProps<any>;
  bodyName: string;
  conditionTag?: string;
  conditionTagOptions?: Array<{ key: string; value: string }>;
  subjectName: string;
  onEditorReady?: (editor: Editor | null) => void;
  placeholderOptions?: Array<Record<string, string>>;
}

const CampaignEmailTemplate: FC<ICampaignEmailTemplate> = ({
  formik,
  bodyName,
  conditionTag,
  conditionTagOptions,
  subjectName,
  onEditorReady,
  placeholderOptions,
}) =>
  (
    <>
      <Box sx={styles.row}>
        <Typography sx={styles.rowLabel}>{strings.subject}</Typography>
        <Box flex={6}>
          <CustomTextField
            name={subjectName}
            formik={formik}
            variant={TextFieldVariants.filled}
            placeholder={strings.subject}
            id={subjectName}
            customTextFieldStyle={genericClasses.customFilledInput}
          />
        </Box>
      </Box>

      <Box sx={styles.row}>
        <Typography sx={styles.rowLabel}>{strings.body}</Typography>
        <Box sx={[styles.editorContainer]}>
          <EmailEditor
            formik={formik}
            name={bodyName}
            conditionTag={conditionTag}
            conditionTagOptions={conditionTagOptions}
            onEditorReady={onEditorReady}
            previousContent={formik.values[bodyName]}
            placeholderPluginOptions={placeholderOptions}
          />
        </Box>
      </Box>

    </>
  );

export default CampaignEmailTemplate;
